import MasterApiBase from "./master-api.base";

const CATEGORY_ENDPOINT = "/categories";

export default class MembersApi extends MasterApiBase {
	batchUpdate = async (data) => {
		return this.axios.patch(`${CATEGORY_ENDPOINT}/batch-update-display`, data);
	};
}
